var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('product-list-container',{attrs:{"title":_vm.spec === 'novelties' ? 'Новинки' : _vm.spec === 'hits' ? 'Хиты' : 'Распродажа',"spec":_vm.spec,"viewMode":"full"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }